import React from 'react';
import { useMsal } from '@azure/msal-react';
import { appInsights } from '../../services/analytics/appInsights';

const SignOutButton = () => {
  const { instance } = useMsal();

  const handleLogout = () => {
    // Track logout attempt
    if (appInsights && process.env.NODE_ENV === 'production') {
      appInsights.trackEvent({
        name: 'LogoutInitiated',
        properties: {
          timestamp: new Date().toISOString()
        }
      });

      // Clear user context
      appInsights.clearAuthenticatedUserContext();
    }

    instance.logoutPopup().catch(e => {
      console.error(e);
      
      if (appInsights && process.env.NODE_ENV === 'production') {
        appInsights.trackException({
          exception: e,
          properties: {
            context: 'LogoutPopup'
          }
        });
      }
    });
  };

  return (
    <button 
      onClick={handleLogout}
      className="w-full rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600"
    >
      Sign Out
    </button>
  );
};

export default SignOutButton; 